import React from "react";
import { useHistory } from "react-router-dom";
import bacteria from "../../Assets/bacteria.png";
import bandage from "../../Assets/bandage.png";
import blood from "../../Assets/blood.png";
import bone from "../../Assets/bone.png";
import brain from "../../Assets/brain.png";
import child from "../../Assets/child.png";
import cough from "../../Assets/cough.png";
import diabetes from "../../Assets/diabetes.png";
import eye from "../../Assets/eye.png";
import gender from "../../Assets/gender.png";
import heart from "../../Assets/heart.png";
import kidney from "../../Assets/kidney.png";
import lab from "../../Assets/lab.png";
import liver from "../../Assets/liver.png";
import lungs from "../../Assets/lungs.png";
import man from "../../Assets/man.png";
import prenatal from "../../Assets/prenatal.png";
import ribbon from "../../Assets/ribbon.png";
import stomach from "../../Assets/stomach.png";
import surgery from "../../Assets/surgery.png";
import virus from "../../Assets/virus.png";
import woman from "../../Assets/woman.png";
import yoga from "../../Assets/yoga.png";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 10,
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
  },
  link: {
    color: theme.palette.common.white,
  },
}));

const Categories = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);

  return (
    <Paper className={classes.paper}>
      <List
        aria-labelledby="categories-subheader"
        component="nav"
        subheader={
          <ListSubheader
            component="div"
            id="categories-subheader"
            disableSticky
          >
            Condition and Medicine Categories
          </ListSubheader>
        }
      >
        <ListItem button onClick={() => history.push("/forum/covid-19")}>
          <ListItemAvatar>
            <Avatar alt="Covid-19" src={virus} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Covid-19" />
        </ListItem>

        <ListItem button onClick={() => history.push("/forum/allergies")}>
          <ListItemAvatar>
            <Avatar alt="Allergies" src={cough} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Allergies" />
        </ListItem>
        <ListItem
          button
          onClick={() => history.push("/forum/bones_joints_and_muscles")}
        >
          <ListItemAvatar>
            <Avatar
              alt="Bones, Joints and Muscles"
              src={bone}
              variant="rounded"
            />
          </ListItemAvatar>
          <ListItemText primary="Bones, Joints and Muscles" />
        </ListItem>
        <ListItem button onClick={() => history.push("/forum/cancer")}>
          <ListItemAvatar>
            <Avatar alt="Cancer" src={ribbon} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Cancer" />
        </ListItem>
        <ListItem button onClick={() => history.push("/forum/child_health")}>
          <ListItemAvatar>
            <Avatar alt="Child Health" src={child} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Child Health" />
        </ListItem>
        <ListItem
          button
          onClick={() => history.push("/forum/diabetes_and_hormone_problem")}
        >
          <ListItemAvatar>
            <Avatar
              alt="Diabetes and Hormone Problem"
              src={diabetes}
              variant="rounded"
            />
          </ListItemAvatar>
          <ListItemText primary="Diabetes and Hormone Problem" />
        </ListItem>
        <ListItem button onClick={() => history.push("/forum/eyes")}>
          <ListItemAvatar>
            <Avatar alt="Eyes" src={eye} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Eyes" />
        </ListItem>
        <ListItem button onClick={() => history.push("/forum/kidney")}>
          <ListItemAvatar>
            <Avatar alt="Kidney" src={kidney} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Kidney" />
        </ListItem>
        <ListItem button onClick={() => history.push("/forum/infections")}>
          <ListItemAvatar>
            <Avatar alt="Infections" src={bacteria} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Infections" />
        </ListItem>
        <ListItem
          button
          onClick={() => history.push("/forum/liver_and_gallbladder")}
        >
          <ListItemAvatar>
            <Avatar alt="Liver and Gallbladder" src={liver} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Liver and Gallbladder" />
        </ListItem>
        <ListItem
          button
          onClick={() =>
            history.push("/forum/operations_and_surgical_procedure")
          }
        >
          <ListItemAvatar>
            <Avatar
              alt="Operations and Surgical Procedure"
              src={surgery}
              variant="rounded"
            />
          </ListItemAvatar>
          <ListItemText primary="Operations and Surgical Procedure" />
        </ListItem>
        <ListItem
          button
          onClick={() => history.push("/forum/test_and_investigation")}
        >
          <ListItemAvatar>
            <Avatar alt="Test and Investigation" src={lab} variant="rounded" />
          </ListItemAvatar>
          <ListItemText primary="Test and Investigation" />
        </ListItem>
        {/* <ListItem button onClick={() => setOpen((open) => !open)}>
          <ListItemText primary={open ? "Show Less" : "Show More"} />
          <ListItemSecondaryAction>
            <IconButton onClick={() => setOpen((open) => !open)}>
              {open ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem> */}
        <Collapse in={open} mountOnEnter unmountOnExit>
          <ListItem
            button
            onClick={() => history.push("/forum/blood_and_immune_system")}
          >
            <ListItemAvatar>
              <Avatar
                alt="Blood and Immune System"
                src={blood}
                variant="rounded"
              />
            </ListItemAvatar>
            <ListItemText primary="Blood and Immune System" />
          </ListItem>
          <ListItem
            button
            onClick={() => history.push("/forum/brain_and_nerves")}
          >
            <ListItemAvatar>
              <Avatar alt="Brain and Nerves" src={brain} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Brain and Nerves" />
          </ListItem>
          <ListItem
            button
            onClick={() => history.push("/forum/chest_and_lungs")}
          >
            <ListItemAvatar>
              <Avatar alt="Chest and Lungs" src={lungs} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Chest and Lungs" />
          </ListItem>
          <ListItem button onClick={() => history.push("/forum/sexual_health")}>
            <ListItemAvatar>
              <Avatar alt="Sexual Health" src={gender} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Sexual Health" />
          </ListItem>
          <ListItem
            button
            onClick={() => history.push("/forum/guts_bowel_and_stomach")}
          >
            <ListItemAvatar>
              <Avatar
                alt="Gut, Bowel and Stomach"
                src={stomach}
                variant="rounded"
              />
            </ListItemAvatar>
            <ListItemText primary="Gut, Bowel and Stomach" />
          </ListItem>
          <ListItem button onClick={() => history.push("/forum/heart_health")}>
            <ListItemAvatar>
              <Avatar alt="Heart Health" src={heart} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Heart Health" />
          </ListItem>
          <ListItem
            button
            onClick={() => history.push("/forum/injury_and_accidents")}
          >
            <ListItemAvatar>
              <Avatar
                alt="Injury and Accidents"
                src={bandage}
                variant="rounded"
              />
            </ListItemAvatar>
            <ListItemText primary="Injury and Accidents" />
          </ListItem>
          <ListItem
            button
            onClick={() => history.push("/forum/pregnancy_and_newborn")}
          >
            <ListItemAvatar>
              <Avatar
                alt="Pregnancy and Newborn"
                src={prenatal}
                variant="rounded"
              />
            </ListItemAvatar>
            <ListItemText primary="Pregnancy and Newborn" />
          </ListItem>
          <ListItem button onClick={() => history.push("/forum/mens_helath")}>
            <ListItemAvatar>
              <Avatar alt="Men's Health" src={man} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Men's Health" />
          </ListItem>
          <ListItem button onClick={() => history.push("/forum/womens_health")}>
            <ListItemAvatar>
              <Avatar alt="Women's Health" src={woman} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Women's Health" />
          </ListItem>
          <ListItem
            button
            onClick={() => history.push("/forum/teenage_health")}
          >
            <ListItemAvatar>
              <Avatar alt="Teenage Health" src={yoga} variant="rounded" />
            </ListItemAvatar>
            <ListItemText primary="Teenage Health" />
          </ListItem>
        </Collapse>
        <ListItem button onClick={() => setOpen((open) => !open)}>
          <ListItemText primary={open ? "Show Less" : "Show More"} />
          <ListItemSecondaryAction>
            <IconButton onClick={() => setOpen((open) => !open)}>
              {open ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>
    </Paper>
  );
};

export default Categories;
